var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 73,
    viewBox: "0 0 112 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5391 3.00847C17.0211 8.31106 17.3062 13.8014 17.3062 19.1188C17.3062 25.6161 17.5976 32.2261 17.0363 38.6813C16.0838 49.6352 17.0505 60.3474 17.0505 71.2856",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47461 38.0421C4.78843 38.0421 7.23577 38.1507 9.43586 37.4738C11.6222 36.8011 14.6083 37.2749 16.9086 37.2749C19.4364 37.2749 21.9127 37.0192 24.4665 37.0192C26.4798 37.0192 28.3348 37.2749 30.348 37.2749",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7491 1.62753C75.7491 16.8782 75.9339 32.0984 75.9339 47.3477C75.9339 52.0625 75.5644 56.7488 75.5644 61.4518C75.5644 64.0867 75.3796 66.7106 75.3796 69.3455C75.3796 70.0541 75.3737 69.3832 75.3796 69.0273C75.3968 67.9973 75.5644 66.9856 75.5644 65.9478C75.5644 62.918 75.7491 59.899 75.7491 56.8838C75.7491 53.724 75.8374 50.535 76.9399 47.5427C78.6553 42.8865 82.515 39.1605 87.4307 38.0682C92.0796 37.0351 97.493 37.0256 101.761 39.4642C102.951 40.1446 104.086 40.5512 104.758 41.8251C105.428 43.0943 106.218 44.3228 106.934 45.5616C107.853 47.1523 108.217 49.0159 108.638 50.7762C109.133 52.8429 109.894 54.9955 109.931 57.1405C110.013 61.8638 110.116 66.5565 110.116 71.2856",
    stroke: "#EE2B00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/TH.c19f4c241256ec6578918eab88e24196.svg";
export { ForwardRef as ReactComponent };